import { ErrorCapturer } from '@/adapters/ErrorCapturer';
import { QuestionResolutionError } from '@/errors/questionResolution';

export const handleQuestionResolutionError = (error: unknown) => {
  if (!(error instanceof QuestionResolutionError)) return;

  new ErrorCapturer(error).dispatchError();
  return error.message;
};
